import { add as _add } from "../../api";

const BASE_URL = "/general/log";

export function add({ payload, onSuccess = () => {}, onError = () => {} }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}
